import { gql } from "@apollo/client";

export const AssetIotConnection = gql`
    query AssetIotConnection ($id: ID!) {
        assetLocation (id: $id) {
            id
            iotConnection {
                id
                connectionStatus
                gateway {
                    id
                    imei
                }
            }
        }
    }
`;
